import { render, staticRenderFns } from "./ProcessSection.vue?vue&type=template&id=cef3c0fa&scoped=true"
import script from "./ProcessSection.vue?vue&type=script&lang=js"
export * from "./ProcessSection.vue?vue&type=script&lang=js"
import style0 from "./ProcessSection.vue?vue&type=style&index=0&id=cef3c0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef3c0fa",
  null
  
)

export default component.exports